import SiteManageContainer from '../../../../components/SitesManage/Sites/containers/SiteManageContainer'

export default SiteManageContainer
